import { Component, OnInit, OnDestroy } from '@angular/core';
import { IPlatformToolComponent, IPlatformToolHandler } from '@shared/components/platform-tool/platform-tool-container/platform-tool-component';
import { MagicLinkModel, TabModel } from '@shared/models/platform-tool-models';
import { InvalidateSubject } from '@shared/helpers/invalidate.subject';
import { PlatformCommandResponse, PlatformCommand, ContentScope } from '@shared/commands/command-base';
import { Subject, Observable } from 'rxjs';
import { DynamicFieldItem } from '@shared/components/dynamic-form/dynamic-form-item';
import { Router, ActivatedRoute } from '@angular/router';
import { CommandService } from '@core/services/command.service';
import { SnackBarService } from '@core/services/snack-bar.service';
import { MatDialog } from '@angular/material/dialog';
import { DetailsInstructionService } from '@shared/services/details-instruction-service';
import { Store, select } from '@ngrx/store';
import { IQueryState } from '@shared/store/reducers/query.reducer';
import { PlatformSidebarState } from '@shared/components/platform-sidebar/store/platform-sidebar.reducer';
import { CollaborationState } from '@features/task-manager/collaboration/store/collaboration.reducer';
import { DialogService } from '@shared/services/dialog-service';
import { FileStoreCommonService } from '@features/file-manager/services/file-store-common.service';
import { takeUntil, skip } from 'rxjs/operators';
import { QueryProvider } from '@shared/queries/query-provider';
import { getQueryResponse } from '@shared/store/selectors/query.selector';
import { SetActivityFeedAction } from '@shared/components/platform-sidebar/store/platform-sidebar.action';
import { SourceTypes, FieldefinitionDataType, BasketId } from '@features/dac6-reporter/Fields';
import { Guid } from 'guid-typescript';
import { UpdatePreArrangementCommand } from '@features/dac6-reporter/commands/dac6-reporter.command';
import { BasketProvider } from '@shared/models/basket-provider';
import { CreateChatConversationCommand } from '@features/task-manager/collaboration/store/collaboration.command';
import { CreateChatConversationAction } from '@features/task-manager/collaboration/store/collaboration.action';
import { DialogModel } from '@shared/models/dialog.model';
import { Configuration } from '@shared/models/configuration';
import { ConversationComponentName } from '@features/task-manager/collaboration/store/collaboration.constants';

@Component({
    standalone: false,
    selector: 'particle-pre-arrangement-detail-platform-container',
  templateUrl: './pre-arrangement-detail-platform-container.component.html',
  styleUrls: ['./pre-arrangement-detail-platform-container.component.scss']
})
export class PreArrangementDetailPlatformContainerComponent  implements OnInit, OnDestroy,IPlatformToolComponent {
  handler: IPlatformToolHandler;
  magicLinkModel: MagicLinkModel;
  selectedTab: TabModel;

  id: any;
  ngUnsubscribe$ = new Subject<void>();
  item$: Observable<any>;
  sourceType: string;
  autoSave: boolean;
  item: any;
  isDirty: boolean = false;
  editedFields: string[] = [];
  endpointName: string;
  isProjectSpecific: boolean;
  showOriginal: boolean;
  invalidateSubject: InvalidateSubject  = new InvalidateSubject();
  showLanguageOption: boolean;
  totalChanges: number = 0;
  autoSaveInterval;
  formField: DynamicFieldItem;
  fieldConfig: any;
  selectedSectionHearderKey: string;
  isAutoTagRefresh: boolean;
  changedValuesFieldDefination = [];
  constructor(private router: Router,
    protected activatedRoute: ActivatedRoute,
    private commandService: CommandService,
    private detailsInstructionService: DetailsInstructionService,
    private queryState: Store<IQueryState>,
    private platformSidebarStore: Store<PlatformSidebarState>,
    private collaborationStore: Store<CollaborationState>,
    private dialogService: DialogService,
    private fileStoreCommonService: FileStoreCommonService) {
      this.sourceType = 'PreArrangement';
      this.endpointName = 'Dac6Api';
      this.isProjectSpecific = false;
      this.showOriginal = false;
      this.showLanguageOption = false;
      this.invalidateSubject = new InvalidateSubject();
      this.autoSave = false;
      this.selectedSectionHearderKey = '';
    }
  ngOnInit(): void {
    this.invalidateSubject.getObservale().pipe(takeUntil(this.ngUnsubscribe$)).subscribe(state => {
      if (state.indexOf('SaveChangesOnPageChangeOrTab') >= 0) {
        if (this.editedFields.length > 0) {this.save(); }
      }
    });
    this.id = this.magicLinkModel.fieldValues['PreArrangementId']; // will be gotten from magic link
    this.trackPreArrangementViewActivity(this.id);
    this.item$ = this.queryState.pipe(takeUntil(this.ngUnsubscribe$), select(getQueryResponse, 'PreArrangementRowById'));
    this.item$.pipe(skip(1), takeUntil(this.ngUnsubscribe$)).subscribe(state => {
      if (this.isAutoTagRefresh) {
        this.isAutoTagRefresh = false;
        this.autoTagRefresh(state);
        return;
      }
      const item = state.item;
      if (item && item.cells) {
        if (!this.item) {
          this.item = item;
          this.magicLinkModel.fieldValues['item'] = this.item;
        }
        // this.platformSidebarStore.dispatch(new SetActivityFeedAction({type: 'ReferenceCode', id: this.item.cells['ReferenceCode'].value, title: this.item.cells['CaseId'].value, isDefault: false, isUserAction: false}));
        this.formField = state.formField;
        this.fieldConfig = state.fieldConfig;
        Object.keys(item.cells).forEach(key => {
          if (!this.item.cells[key]) {
            this.item.cells[key] = {};
          }

          this.item.cells[key].isDirty = false;
          this.item.cells[key].actualValue = item.cells[key].value;
          this.item.cells[key].value = item.cells[key].value;
          this.item.cells[key].displayText = item.cells[key].displayText;
        });

        this.isDirty = false;
      }
      this.editedFields.splice(0, this.editedFields.length);
    });
    QueryProvider.invokeQuery(this.queryState, 'PreArrangementRowById', {'[ID]': this.id});
    this.autoSaveInterval = setInterval( () => {
      // console.log("Calling Auto Save: dirty value: " + this.isDirty + " Auto Save value: " + this.autoSave);
      if (this.isDirty && this.autoSave) {
        this.save();
      }
    }, 30000);
  }
  async canDeactivate() {
    let res = true;
    if (this.editedFields.length > 0) {
      const question = 'You have unsaved changes. Do you want to save these changes before continuing?';
      const dialogRef = this.dialogService.showConfirmDialog('Unsaved Changes', 'Yes', 'No', null, question);
      dialogRef.pipe(takeUntil(this.ngUnsubscribe$)).subscribe(data => {
        if (data.action === 'OK') {
          this.save();
          res = false;
        } else if (data.action === 'Closed') {
          res = false;
        }
      });
      await dialogRef.toPromise();
    }
    return res;
  }
  trackPreArrangementViewActivity(id: string){
    const command = new PlatformCommand('TrackPreArrangementViewCommand','DAC6Api');
    command.fieldValues['Id'] = id;
    command.fieldValues['SourceType'] = SourceTypes.PreArrangement;
    this.commandService.executePlatformCommand(command).subscribe((response: any)=>{
      console.log(response);
    })
  }
  navigateToCaseFolder() {
    let relativePath = 'DAC6 Reporter/[CASE_ID]/Pre-Arrangements';
    const caseId = this.item.cells['CaseId'].value;
    relativePath = relativePath.replace('[CASE_ID]', caseId);
    // const relativeUrl$ = this.queryState.pipe(select(getQueryResponse, 'UrlByRelativePath'))
    //   .pipe(take(2));
    // relativeUrl$.pipe(takeUntil(this.ngUnsubscribe$)).subscribe(state => {
    //   console.log('RelativeUrl', state);
    //   if (state) {
    //     this.router.navigateByUrl(state);
    //   }
    // });

    // QueryProvider.invokeQuery(this.queryState, 'UrlByRelativePath', {'[RELATIVE_PATH]': relativePath});
    this.fileStoreCommonService.navigateToClientFolderUsingRelativepath(relativePath);
  }

 openConversation() {
   const sourceInfoDictionary = {
     'sourceInfoDictionary': {
       CaseGuid: this.item.cells['CaseGUID'].value,
       caseId: this.item.cells['CaseId'].displayText
     }
   };
   const createChatConversationCommand = new CreateChatConversationCommand(
     '[COMPANY_ID]-chat',
     `${this.item.cells['CaseId'].displayText}`,
     true,
     0,
     'DAC6',
     [],
     true,
     this.item.cells['CaseGUID'].value,
     sourceInfoDictionary
   );
   createChatConversationCommand.scope = ContentScope.Company;
   this.collaborationStore.dispatch(new CreateChatConversationAction(createChatConversationCommand, ConversationComponentName));
 }
  onValueChanged(event) {
    if (event && event.action === 'ApplyTagsSuccess') {
      this.isAutoTagRefresh = true;
      QueryProvider.invokeQuery(this.queryState, 'PreArrangementRowById', {'[ID]': this.id});
      this.invalidateSubject.invalidate('ApplyTagsSuccess|' + Guid.create().toString());
      return;
    }
    const exist = this.changedValuesFieldDefination.find( o => o.key === event.event.fieldDefinition.key);
    if (!exist) {
      this.changedValuesFieldDefination.push(event.event.fieldDefinition);
    }
    if (event) {
      switch (event.action) {
        case 'ValueChanged':
          this.totalChanges += event.increment;
          this.dirtyChanged();
          break;
        case 'Edit':
          this.save();
          break;
      }
    }
  }
  private dirtyChanged() {
    if (this.totalChanges) {
      // this.saveButtonCaption = `Save (${this.totalChanges})`;
      this.isDirty = true;
      // if (this.autoSave) {
      //   this.save();
      // }
    } else {
      // this.saveButtonCaption = `Save`;
      this.isDirty = false;
    }
  }
  save(): void {
    if (this.editedFields.length) {
      const item = {};
      item['id'] = this.item.id;
      item['fieldValues'] = {};
      this.editedFields.forEach(fieldKey => {
        if (this.item.cells[fieldKey]) {
          item['fieldValues'][fieldKey] = this.item.cells[fieldKey].value;
          const fieldDef = this.changedValuesFieldDefination.find( o => o.key === fieldKey);
          if (fieldDef && fieldDef.dataType === FieldefinitionDataType.Attachment && this.item.cells['fileName']) {
            item['fieldValues'][`${fieldKey}FileName`] = this.item.cells['fileName'];
          }
        }
      });
      const command = new UpdatePreArrangementCommand(item);
      const currentBasket = BasketProvider.getCurrentBasket();
      switch (currentBasket.id){
        case BasketId.Mexico:
          command.IsHallmarkAutomatedCopy = true;
          break;
        default:
      }
      this.commandService.executeCommand(command).pipe(takeUntil(this.ngUnsubscribe$)).subscribe(commandState => {
        // this.snackBarService.showInformation('Pre Arrangement Data Saved');
        QueryProvider.invokeQuery(this.queryState, 'PreArrangementRowById', {'[ID]': this.id});
        this.totalChanges = 0;
        this.dirtyChanged();
        this.invalidateSubject.invalidate('SaveChanges|' + Guid.create().toString());
      });
    } else {
      this.invalidateSubject.invalidate('SaveChanges|' + Guid.create().toString());
    }
  }
  autoSaveChanged(): void {
    if (!this.autoSave) {
      this.save();
    }
  }
  autosave () {
    // fixing build error
  }

  ngOnDestroy(): void {
    if (this.autoSaveInterval) {
      clearInterval(this.autoSaveInterval);
    }
    this.ngUnsubscribe$.next();
    this.ngUnsubscribe$.complete();
  }
  openHallmarkTagging() {
    const dialogueModel = DialogModel.create('Hallmark Tagging', 'HallmarkTagSuggestionDialogComponent', {});
    dialogueModel.maxWidth = '600px';
    dialogueModel.minWidth = '600px';
    this.dialogService.showOkCancelDialog(dialogueModel).subscribe(res => {
      if (res.action === 'OK') {
      }
    });
  }
  selectedSectionIndexChange($event) {
    this.selectedSectionHearderKey = $event;
    if(this.hasHallmarkTagging()){
      this.magicLinkModel.breadcrumbBar.items[0].commands[0].isDisabled = false;
    } else {
      this.magicLinkModel.breadcrumbBar.items[0].commands[0].isDisabled = true;
    }
  }
  hasHallmarkTagging() {
    const currentBasket = Configuration.getCurrentBasket();
    if (currentBasket) {
      return currentBasket.basketKey === '' && this.selectedSectionHearderKey.toLowerCase().includes('_hallmarktagging');
    }
    return this.selectedSectionHearderKey.toLowerCase().includes('_hallmarktagging');
  }

  private autoTagRefresh(state: any) {
    if (!this.item.cells['Suggested_Hallmarks']) {
      this.item.cells['Suggested_Hallmarks'] = {};
    }
    if (!this.item.cells['ApplyTags']) {
      this.item.cells['ApplyTags'] = {};
    }

    if (state.item.cells['Suggested_Hallmarks'] && state.item.cells['Suggested_Hallmarks'].value) {
      this.item.cells['Suggested_Hallmarks'].isDirty = false;
      this.item.cells['Suggested_Hallmarks'].actualValue = state.item.cells['Suggested_Hallmarks'].value;
      this.item.cells['Suggested_Hallmarks'].value = state.item.cells['Suggested_Hallmarks'].value;
      this.item.cells['Suggested_Hallmarks'].displayText = state.item.cells['Suggested_Hallmarks'].displayText;
    }

    if (state.item.cells['ApplyTags'] && state.item.cells['ApplyTags'].value) {
      this.item.cells['ApplyTags'].isDirty = false;
      this.item.cells['ApplyTags'].actualValue = state.item.cells['ApplyTags'].value;
      this.item.cells['ApplyTags'].value = state.item.cells['ApplyTags'].value;
      this.item.cells['ApplyTags'].displayText = state.item.cells['ApplyTags'].displayText;
    }
  }
  onSelectionFieldChanged(event){
    if(event.metaData && event.metaData['DirectoryPath']){
      const caseId = this.item.cells['CaseId'].value;
      event.metaData['DirectoryPath'] = event.metaData['DirectoryPath'].replace('[CASE_ID]' ,caseId );
    }
    const currentSourceType = BasketProvider.getBasketMappedSourceType(SourceTypes.Arrangement);
    this.detailsInstructionService.openFieldDefinitionFieldDetial(event, currentSourceType);
  }
  onLoad() {
    throw new Error("Method not implemented.");
  }
  onBeforeExecuteNextCommand(): boolean {
    throw new Error("Method not implemented.");
  }
  onAfterExecuteNextCommand(nextCommandResponse: PlatformCommandResponse) {
    throw new Error("Method not implemented.");
  }
  onBeforeExecutePreviousCommand(): boolean {
    throw new Error("Method not implemented.");
  }
  onAfterExecutePreviousCommand(previousCommandResponse: PlatformCommandResponse) {
    throw new Error("Method not implemented.");
  }



}
